export class PipeMaterialGroupModel {
    _id: string;
    id: number;
    name: string;
    description: string;
    pipeMaterialTypeId: number;

    constructor(_id = null,
        id = null,
        name = '',
        description = '',
        pipeMaterialTypId = null) {
            this._id = _id;
            this.id = id;
            this.name = name;
            this.description = description;
            this.pipeMaterialTypeId = this.pipeMaterialTypeId;
    }
}
